import React, { FC } from 'react';

import { LoadingPlaceholder } from 'modules/UI';

export const DeveloperLoadingPlaceholder: FC = () => <LoadingPlaceholder height="100%" />;
